import { UserPlusIcon } from 'lucide-react'
import { useState } from 'react'

import InvitePartnerAdminModal from 'components/partners/InvitePartnerAdminModal'
import { Button } from 'slab'

interface AdminInvitePartnerAdminProps {
  partnerId: string
}

export default function AdminInvitePartnerAdmin ({ partnerId }: AdminInvitePartnerAdminProps) {
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false)

  return (
    <>
      <Button
        leftIcon={UserPlusIcon}
        size='large'
        variant='primary'
        onClick={() => setIsInviteModalOpen(true)}
      >
        Invite team member
      </Button>

      <InvitePartnerAdminModal
        partnerId={partnerId}
        isOpen={isInviteModalOpen}
        onClose={() => setIsInviteModalOpen(false)}
        onSuccess={() => window.location.reload()}
      />
    </>
  )
}
